<template>
  <div class="wrapper">
    <div
      class="title"
      style="
        font-weight: bold;
        font-size: 24px;
        padding: 5px;
        border-left: 4px solid #618afd;
      "
    >
      学习概况及趋势
    </div>
    <br />
    时间筛选：<el-date-picker
      size="mini"
      v-model="totalLearnSearchCondition.timeRange"
      type="daterange"
      :picker-options="pickerOptions"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      align="right"
      value-format="yyyy-MM-dd"
      @change="
        (val) => {
          [
            totalLearnSearchCondition.startTime,
            totalLearnSearchCondition.endTime,
          ] = val;
        }
      "
    >
    </el-date-picker
    >&emsp;
    <el-button size="mini" type="primary" @click="totalLearnSearch"
      >查询</el-button
    >
    <div class="inshortBar">
      <div class="detailBox">
        <div class="key">学习人数</div>
        <div class="value">{{ totalLearnData.learnTotalNum }}</div>
      </div>
      <div class="detailBox">
        <div class="key">总学习时长(小时)</div>
        <div class="value">{{ totalLearnData.effectiveTimeTotal }}</div>
      </div>
      <div class="detailBox">
        <div class="key">人均学习时长(小时)</div>
        <div class="value">{{ totalLearnData.avgLearnTime }}</div>
      </div>
      <div class="detailBox">
        <div class="key">课程学习次数</div>
        <div class="value">{{ totalLearnData.catalogLearnTotal }}</div>
      </div>
      <div class="detailBox">
        <div class="key">已学习的课程数</div>
        <div class="value">{{ totalLearnData.finishNum }}</div>
      </div>
      <div class="detailBox">
        <div class="key">课程完课率</div>
        <div class="value">{{ totalLearnData.divide }}%</div>
      </div>
    </div>
    <div id="learnTotal">
      时间筛选：<el-date-picker
        size="mini"
        v-model="learnTimeSearchCondition.timeRange"
        type="daterange"
        :picker-options="pickerOptions"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        align="right"
        value-format="yyyy-MM-dd"
        @change="
          (val) => {
            [
              learnTimeSearchCondition.startTime,
              learnTimeSearchCondition.endTime,
            ] = val;
          }
        "
      >
      </el-date-picker>
      &emsp;
      <el-button size="mini" type="primary" @click="learnTimeSearch"
        >查询</el-button
      >
      <br /><br />
      <v-chart :option="learnTimeData" style="height: 400px"></v-chart>
    </div>
    <div id="learnDetail">
      时间筛选"：<el-date-picker
        size="mini"
        v-model="learnDataSearchCondition.timeRange"
        type="daterange"
        :picker-options="pickerOptions"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        align="right"
        value-format="yyyy-MM-dd"
        @change="
          (val) => {
            [
              learnDataSearchCondition.startTime,
              learnDataSearchCondition.endTime,
            ] = val;
          }
        "
      >
      </el-date-picker
      >&emsp;
      <el-button size="mini" type="primary" @click="learnDataSearch"
        >查询</el-button
      >
      <br /><br />
      <v-chart :option="learnDataData" style="height: 400px"></v-chart>
    </div>
    <div class="totalLearnContainer">
      <div
        class="title"
        style="
          background: #eee;
          font-weight: bold;
          font-size: 24px;
          padding: 10px;
        "
      >
        学员排行
      </div>
      <br />

      <div class="twosideFlex">
        <div class="flex1">
          <div style="font-size: 20px; padding: 10px">学习时间TOP10学员</div>
          <el-table :data="totalLearnData.learnTimeTopList" border>
            <el-table-column type="index" label="排名" width="60px">
            </el-table-column>
            <el-table-column prop="userName" label="学员"> </el-table-column>
            <el-table-column prop="totalTime" label="学习时长(小时)">
            </el-table-column>
          </el-table>
        </div>
        <div class="flex1">
          <div style="font-size: 20px; padding: 10px">
            学习课程个数TOP10学员
          </div>
          <el-table
            :data="totalLearnData.learnCatalogTopList"
            border
            style="width: 100%"
          >
            <el-table-column label="排名" type="index" width="60px">
            </el-table-column>
            <el-table-column prop="userName" label="学员"> </el-table-column>
            <el-table-column
              prop="catalogIdNum"
              label="学习课程数"
            ></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let now = new Date(),
  sevenDaysAgo = new Date(now.getTime() - 3600 * 1000 * 24 * 7);
let nowStr = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`,
  sevenDaysAgoStr = `${sevenDaysAgo.getFullYear()}-${
    sevenDaysAgo.getMonth() + 1
  }-${sevenDaysAgo.getDate()}`;
import {
  learnTimeAnalysis,
  learnDataAnalysis,
  totalLearnData,
} from "@/api/bus";

import ECharts from "vue-echarts";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart, LineChart, PieChart, RadarChart } from "echarts/charts";
import {
  GridComponent,
  TooltipComponent,
  PolarComponent,
  TitleComponent,
} from "echarts/components";

use([
  CanvasRenderer,
  BarChart,
  GridComponent,
  TooltipComponent,
  PolarComponent,
  PieChart,
  LineChart,
  RadarChart,
  TitleComponent,
]);
import Print from "print-js";
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      learnTimeSearchCondition: {
        startTime: sevenDaysAgoStr,
        endTime: nowStr,
        timeRange: [sevenDaysAgoStr, nowStr],
      },
      learnDataSearchCondition: {
        startTime: sevenDaysAgoStr,
        endTime: nowStr,
        timeRange: [sevenDaysAgoStr, nowStr],
      },
      totalLearnSearchCondition: {
        startTime: sevenDaysAgoStr,
        endTime: nowStr,
        timeRange: [sevenDaysAgoStr, nowStr],
      },
      learnTimeData: {},
      learnDataData: {},
      totalLearnData: { learnCatalogTopList: [], learnTimeTopList: [] },
    };
  },
  created() {},
  mounted() {
    this.pageInit();
  },
  methods: {
    learnTimeSearch() {
      learnTimeAnalysis(this.learnTimeSearchCondition).then((data) => {
        this.learnTimeData = data.lineRoot;
      });
    },
    learnDataSearch() {
      learnDataAnalysis(this.learnDataSearchCondition).then((data) => {
        this.learnDataData = data.lineRoot;
      });
    },
    totalLearnSearch() {
      totalLearnData(this.totalLearnSearchCondition).then((data) => {
        Object.assign(this.totalLearnData, data);
      });
    },

    pageInit() {
      this.learnTimeSearch();
      this.learnDataSearch();
      this.totalLearnSearch();
    },
  },
  components: {
    "v-chart": ECharts,
  },
};
</script>

<style scoped lang="less">
.wrapper {
  width: 1200px;
  margin: auto;
  padding: 40px;
  background: #fff;
}
.twosideFlex {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}
.flex1 {
  flex: 1;
}
.flex1 + .flex1 {
  margin-left: 20px;
}
.inshortBar {
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  .detailBox {
    width: 16%;
    border: 1px solid #ccc;
    height: 120px;
    padding: 20px;
    .key {
      font-size: 14px;
    }
    .value {
      font-size: 28px;
    }
  }
}
</style>
